import React, { useEffect } from "react";

const Modal = ({ handleClose, showClose, show, children }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";

  const closeModal = (event) => {
    event.stopPropagation();
    if (
      handleClose !== undefined &&
      (event.target.id == "modal-container" || event.keyCode == 27)
    ) {
      handleClose();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", closeModal, false);

    return () => {
      document.removeEventListener("keydown", closeModal, false);
    };
  }, []);

  return (
    <div
      id="modal-container"
      className={showHideClassName}
      onClick={(event) => closeModal(event)}
      onKeyPress={(event) => closeModal(event)}
    >
      <section className="modal-main">
        {showClose && (
          <div className="exit-button" onClick={() => handleClose()}></div>
        )}
        {children}
      </section>
    </div>
  );
};

export default Modal;
